/**
 * KOYAH Horizon ↔ Appstle Subscribe & Save bridge
 * Keeps form[name=selling_plan] in sync with the Appstle widget so
 * product-form FormData includes the selected selling plan on ATC.
 */
(function () {
  if (window.__koyahSsBridgeLoaded) return;
  window.__koyahSsBridgeLoaded = true;

  var INPUT_NAME = 'selling_plan';
  var BRIDGE_ATTR = 'data-koyah-ss-bridge';

  function mainForms() {
    return Array.prototype.slice.call(
      document.querySelectorAll('form[data-type="add-to-cart-form"][id^="BuyButtons-ProductForm"]')
    );
  }

  function ensureBridge(form) {
    var el = form.querySelector('input[' + BRIDGE_ATTR + ']');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = INPUT_NAME;
      el.setAttribute(BRIDGE_ATTR, '1');
      form.appendChild(el);
    }
    return el;
  }

  function readAppstlePlan() {
    var widget =
      document.querySelector('.appstle_sub_widget') ||
      document.querySelector('#appstle_subscription_widget0');
    if (!widget) {
      try {
        return new URLSearchParams(window.location.search).get('selling_plan') || '';
      } catch (e) {
        return '';
      }
    }
    var checked = widget.querySelector('input[name="' + INPUT_NAME + '"]:checked');
    if (!checked || !checked.value) return '';
    var sel =
      widget.querySelector('select#appstle_selling_plan0') ||
      widget.querySelector('select[id^="appstle_selling_plan"]');
    if (sel && sel.value) return String(sel.value);
    return String(checked.value);
  }

  function sync() {
    var plan = readAppstlePlan();
    mainForms().forEach(function (form) {
      ensureBridge(form).value = plan;
    });
  }

  [
    'AppstleSubscription:SubscriptionWidget:SellingPlanSelected',
    'AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected',
    'AppstleSubscription:SubscriptionWidget:sellingPlanChanged',
    'AppstleSubscription:SubscriptionWidget:widgetInitialised',
    'AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated'
  ].forEach(function (evt) {
    document.addEventListener(evt, sync);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.appstle_sub_widget')) return;
    if (t.name === INPUT_NAME || (t.tagName === 'SELECT' && t.id && t.id.indexOf('appstle_selling_plan') === 0)) {
      sync();
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('product-form-component button, .add-to-cart-button, button[name="add"]')) {
        sync();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('form[data-type="add-to-cart-form"]')) {
        sync();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  setTimeout(sync, 500);
  setTimeout(sync, 2000);
})();
